import React, { useEffect, useState } from "react";
import styles from "../TriggerField.module.scss";
import { TextField } from "@mui/material";
import { CustomDropdown } from "components/shared/customDropdown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems } from "@redux/slices/triggerSlice";
import { LocationFilterContainer } from "components/pages/tasks/components/LocationFilterContainer";
import { setPublish } from "@redux/slices/globalSlice";
import CustomAsyncAutoComplete from "components/shared/customAsyncSelect";
import { LOCATION } from "services/apiEndpoints";

const optionsArray = [
    { label: "is", value: "is" },
    { label: "is answered", value: "is answered" },
    { label: "is unanswered", value: "is unanswered" },
];

const LocationTrigger = ({ item }) => {
    const { triggerDroppedList } = useSelector((state) => state?.trigger);
    const [localOptions, setLocalOptions] = useState(
        item?.trigger || {
            label: "Location", options: item?.operator || "is",
            value: item?.value || [],
            valueLabel: item?.valueLabel || "",
        });

    const dispatch = useDispatch();

    const handleChange = (name, value, valueLabel) => {
        setLocalOptions((prev) => {
            let updatedOptions = { ...prev, [name]: value, valueLabel: valueLabel || "" };
            if (name === "options") {
                if (value === "is answered" || value === "is unanswered") {
                    updatedOptions = {
                        ...updatedOptions,
                        value: "",
                    };
                } else {
                    updatedOptions = {
                        ...updatedOptions,
                        value: ""
                    };
                }
            }
            return updatedOptions;
        });
    };

    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id);
        dispatch(setDroppedItems(filteredDroppedItems));
        dispatch(setPublish(true))
    };

    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    operator: localOptions?.options || "is",
                    optionLabel: item?.label || "Location",
                    valueLabel: localOptions?.valueLabel || "",
                    value: localOptions?.value || [],
                    trigger: { ...localOptions },
                };
            }
            return e;
        });
        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);

    useEffect(() => {

        setLocalOptions((prev) => ({
            ...prev,
            options: item?.operator || prev.options,
            value: item?.value || prev?.value
        }));
    }, [item?.operator, item?.value]);
    return (
        <div className={styles?.metaContainer}>
            <div className={styles?.field}>
                <TextField value={item?.label || "Location"} disabled name="label" />
                <CustomDropdown
                    width='200px'
                    name="options"
                    isDisabled={item?.type === "meta" ? true : false}
                    options={optionsArray}
                    value={localOptions?.options || ""}
                    onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                />
                {
                    localOptions?.options == "is" &&
                    <CustomAsyncAutoComplete
                        label={false}
                        customStyles={{
                            width: "171px",
                            height: "24px",
                            marginTop: "0px !important",
                        }}
                        defaultValue={{
                            label: localOptions?.valueLabel,
                            value: localOptions?.value
                        }}
                        setSelectedOption={(val) => handleChange("value", val?.value, val?.label)}
                        endpoint={LOCATION}
                        dataCb={(data) => (data.data.location.map((location) => {
                            return {
                                label: location.name, value: location._id
                            };
                        })
                        )}
                    />
                }
            </div>


            <div
                style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                onClick={handleDelete}
            >
                <HighlightOffIcon />
            </div>
        </div>
    );
};

export default LocationTrigger;
